export default [
    '/client-list',
    '/client-list-base-ccy',
    '/portfolio',
    '/portfolio/networth',
    '/portfolio/allocations',
    '/portfolio/allocations/group',
    '/portfolio/transactions',
    '/portfolio/holdings',
    '/portfolio/cashflows/future',
    '/portfolio/cashflows/historic',
    '/portfolio/movers/total-pnl',
    '/portfolio/performance',
    '/portfolio/performance-without-ms',
    '/portfolio/portfolio-status',
    '/portfolio/performance/view-strategies',
    '/portfolio/performance/view-strategies-without-create',
    '/portfolio/performance/create-strategy/rule-based',
    '/portfolio/performance/create-strategy/query-based',
    '/portfolio/performance/create-strategy/template-based',
    '/documents-upload',
    '/documents-storage',
    '/statement-processing',
    '/portfolio/documents',
    '/review-all/networth',
    '/review-all/allocations',
    '/review-all/allocations/group',
    '/review-all/transactions',
    '/review-all/holdings',
    '/review-all/cashflows/future',
    '/review-all/cashflows/historic',
    '/review-all/movers/total-pnl',
    '/review-all/performance',
    '/review-all/performance-without-ms',
    '/review-all/portfolio-status',
    '/review-all/performance/view-strategies',
    '/review-all/performance/view-strategies-without-create',
    '/review-all/performance/create-strategy/rule-based',
    '/review-all/performance/create-strategy/query-based',
    '/review-all/performance/create-strategy/template-based',
    '/review-all/documents',
    '/superadmin-user-selection',
    '/excel-addin',
    '/excel-addin/intro',
    '/excel-addin/exposure-reports',
    '/reports/tableau-to-ppt',
    '/reports/partner-documents',
    '/reports/tableau-to-ppt/view-reports',
    '/documents-upload',
    '/tableau-analytics',
    '/tableau-analytics/customer-workbooks',
    '/tableau-analytics/tableau-view',
    '/tableau-analytics/:id/:view',
    '/analytics-mappings/view-mappings',
    '/reports',
    '/reports/fee-report',
    '/reports/fee-report/view-reports',
    '/upload-documents/data-management',
    '/upload-documents/documents-storage',
    '/upload-documents/statement-processing',
    '/settings/user-preferences',
    'menu-mappings/view',
];

export const blockedPagesForGroupedClients = [
    'rule-based',
    'query-based',
    'template-based',
];
